import { useEffect, useState } from "react";
import { TTablaDetalleDiversificacion } from "../../../../services/OmniaService";
import React from "react";
import DisplayArrow from "../../../Elements/DisplayArrow/DisplayArrow";
import { FormatDataTableDiversificacion, TDataDiversificacionActivo1, TDataDiversificacionActivo1y2, TDataDiversificacionPosiciones } from "../../Utils/FormatDataTableDiversificacion";
import { TooltipHost } from "@fluentui/react";

interface ITableDiversificacionProps {
    tableData: TTablaDetalleDiversificacion;
    title: string;
}

const BASE_CLASS = "tableDiversificacion";

const TableDiversificacion: React.FC<ITableDiversificacionProps> = ({ tableData, title }) => {

    const formatData = FormatDataTableDiversificacion(tableData);

    const localTheme = window.localStorage.getItem("theme") || "light";

    const maxLevelHeader = ["Tipo de Activo", "Peso", "Volatilidad", "Aportación al Riesgo con    Correlación 1", "Aportación al Riesgo con Correlación Real", "Diferencia", "Beneficio de   Diversificación", "Correlación"]

    const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
    const [expandedMaxRows, setExpandedMaxRows] = useState<Set<string>>(new Set());

    const toggleExpand = (name: string, setState: Function) => {
        setState((prev: Set<string>) => {
            const newSet = new Set(prev);
            newSet.has(name) ? newSet.delete(name) : newSet.add(name);
            return newSet;
        });
    };

    useEffect(() => {
      setExpandedRows(new Set(formatData.map(row => row.name)));
      setExpandedMaxRows(new Set(formatData.flatMap(row => row.children?.map(child => child.name2) ??     [])));

    }, [tableData]);

    const renderExpanseMax = (data: TDataDiversificacionPosiciones[]) => {
        return (
            <React.Fragment>
                {data.map((row) => (
                    <React.Fragment key={row.name2}>
                        <tr className={`${BASE_CLASS}__detail__row ${BASE_CLASS}__${localTheme}`} >
                            <td className="expanse_cell">{row.data.nominstrum}</td>
                            <td>{row.data.peso}%</td>
                            <td>{row.data.volatilidad}%</td>
                            <td>{row.data.aportacion_riesgo_corr1}%</td>
                            <td>{row.data.aportacion_riesgo_corr_real}%</td>
                            <td>{row.data.diferencia}%</td>
                            <td>{row.data.beneficio_diversificacion}%</td>
                            <td>{row.data.correlacion}</td>
                        </tr>
                    </React.Fragment>
                ))}
            </React.Fragment>
        )
    };

    const renderExpanse = (data: TDataDiversificacionActivo1y2[]) => {
        return (
            <React.Fragment>
                {data.map((row) => (
                    <React.Fragment key={row.name2}>
                        <tr onClick={() => toggleExpand(row.name2, setExpandedMaxRows)}>
                            <td className="expanse_cell">
                                {row.children && row.children.length > 0 && <DisplayArrow expanded={expandedMaxRows.has(row.name2)} />}
                                {row.data.tipoactivo2}
                            </td>
                            <td>{row.data.peso_total}%</td>
                            <td></td>
                            <td>{row.data.volatilidad_corr1}%</td>
                            <td>{row.data.volatilidad_corr_real}%</td>
                            <td>{row.data.diferencia}%</td>
                            <td></td>
                            <td></td>
                        </tr>
                        {expandedMaxRows.has(row.name2) && row.children && (
                          <>{renderExpanseMax(row.children)}</>
                        )}
                    </React.Fragment> 
                ))}
                </React.Fragment>
            )
    };

    const renderRows = (data: TDataDiversificacionActivo1[]) => {
        return data.map((row) => (
            <React.Fragment key={row.name}>
                <tr onClick={() => toggleExpand(row.name, setExpandedRows)}>
                    <td>
                        {row.children && <DisplayArrow expanded={expandedRows.has(row.name)}/>}
                        {row.data.tipoactivo1}
                    </td>
                    <td>{row.data.peso_total}%</td>
                    <td></td>
                    <td>{row.data.volatilidad_corr1}%</td>
                    <td>{row.data.volatilidad_corr_real}%</td>
                    <td>{row.data.diferencia}%</td>
                    <td></td>
                    <td></td>
                </tr>
                {expandedRows.has(row.name) && row.children && (
                  <>{renderExpanse(row.children)}</>
                )}
            </React.Fragment>
        ));
    };

    return (
      <div className={BASE_CLASS}>
        <h4>{title}</h4>
          <table>
            <thead>
              <tr className={`${BASE_CLASS}__${localTheme}`}>
                  <th className="first">
                    <TooltipHost content={maxLevelHeader[0]}>
                      <div>{maxLevelHeader[0]}</div>
                    </TooltipHost>
                  </th> 
                  <th>
                    <TooltipHost content={maxLevelHeader[1]}>
                      <div>{maxLevelHeader[1]}</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={maxLevelHeader[2]}>
                      <div>Volat.</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={`${maxLevelHeader[3]} es el resultado de multiplicar el Peso por la Volatilidad.`}>
                      <div>Apt. R. Corr 1</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={`${maxLevelHeader[4]} es el resultado de multiplicar el Peso por la Volatilidad y por la Correlación.`}>
                      <div>Apt. R. Corr Real</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={`${maxLevelHeader[5]} es el resultado de la Aportación al Riesgo con Correlación 1 menos Aportación al Riesgo con Correlación Real.`}>
                      <div>Dif.</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={`${maxLevelHeader[6]} es el resultado de 1 menos Correlación.`}>
                      <div>Benef.</div>
                    </TooltipHost>
                  </th>
                  <th>
                    <TooltipHost content={`${maxLevelHeader[7]}`}>
                      <div>Correlación</div>
                    </TooltipHost>
                  </th>
              </tr>
            </thead>
          <tbody>
            <tr>
              <td className={`${BASE_CLASS}__bold`}>Totales</td>
              <td>{tableData.totales_columna.peso_total}%</td>
              <td></td>
              <td>{tableData.totales_columna.volatilidad_corr1}%</td>
              <td>{tableData.totales_columna.volatilidad_corr_real}%</td>
              <td>{tableData.totales_columna.diferencia}%</td>
              <td></td>
              <td></td>
            </tr>
            {renderRows(formatData)}
          </tbody>
        </table>
      </div>
    );
};

export default TableDiversificacion;